import { render } from "./Timeline.vue?vue&type=template&id=329f8138"
import script from "./Timeline.vue?vue&type=script&lang=ts"
export * from "./Timeline.vue?vue&type=script&lang=ts"
script.render = render

export default script